<template>
	<div class="tabbar" :style="{'padding-bottom': paddingBottomHeight + 'rpx'}">
		<div class="tabbar-item" :class="current == index ? 'tab-active' : ''" v-for="(item, index) in list" :key="index" @click="tabbarChange(item.path)">
			<div class="tabbar-icon">
				<img class="item-img" :src="item.icon_a" v-if="current == index" />
				<img class="item-img" :src="item.icon" v-else />
			</div>
			<div class="item-name" :class="{'tabbarActive': current == index}" v-if="item.text">{{item.text}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			current: String
		},
		data() {
			return {
				token:"",
				customerService:"",
				paddingBottomHeight: 0, //苹果X以上手机底部适配高度
				list: [{
					text: 'Dashboard',
					icon: require('@/assets/images/tabbar/home.png'),
					icon_a: require('@/assets/images/tabbar/homes.png'),
					path: "", //页面路径
				},{
					text: 'product',
					icon: require('@/assets/images/tabbar/product.png'),
					icon_a: require('@/assets/images/tabbar/products.png'),
					path: "product", //页面路径
				},{
					text: 'order',
					icon: require('@/assets/images/tabbar/order.png'),
					icon_a: require('@/assets/images/tabbar/orders.png'),
					path: "order-lists", //页面路径
				},{
					text: 'my',
					icon: require('@/assets/images/tabbar/user.png'),
					icon_a: require('@/assets/images/tabbar/users.png'),
					path: "user", //页面路径
				} ]
			};
		},
		created() {
		},
		watch: {

		},
		methods: {
			tabbarChange(url){
				this.openPage(url)
			}
		}
	};
</script>

<style scoped>
	.tabbarActive {
		color: #6C77D6 !important;

	}
	.tab-active {

	}

	.tabbar {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 65px;
		background-color: #fff;
		display: none;
		align-items: center;
		justify-content: space-evenly;
		z-index: 10;
		border-top: 1px solid #F3F3F3;
	}
	.tabbar-item {
		width: 100%;
		height: 100%;
	}
	.tabbar-item .tabbar-icon {
		width: 100%;
		height: 24px;
		overflow: hidden;
		margin: 11px auto 2px;
	}

	.tabbar-item .item-img {
		width: 24px;
		height: 24px;
		display: block;
		margin: 0 auto;
	}

	.tabbar-item .item-name {
		font-size: 13px;
		height: 20px;
		line-height: 20px;
		color: #878787;
		text-align: center;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	@media (max-width: 767px) {
		.tabbar {
			display: flex;
		}
	}

</style>
